import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pe_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      const path = window.location.pathname;
      if (
        !path.startsWith("/login") &&
        !path.startsWith("/setup-password") &&
        !path.startsWith("/c/")
      ) {
        localStorage.removeItem("pe_token");
        localStorage.removeItem("pe_user");
        window.location.href = "/login?expired=1";
      }
    }
    return Promise.reject(err);
  },
);

export function apiError(err, fallback = "Error inesperado") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return err?.message || fallback;
}

export function getToken() { return localStorage.getItem("pe_token"); }
export function setToken(t) { localStorage.setItem("pe_token", t); }
export function clearToken() { localStorage.removeItem("pe_token"); }

export default api;
